import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { toggleNetworkWarnings } from "../../logic/actions/apiFetch";
import "./style.css";

export default function SlowNetworkWarning() {
  const [showMessage, setShowMessage] = useState(false);
  let mounted = useRef(true);
  let dispatch = useDispatch();

  function onClose() {
    setShowMessage(false);
    toggleNetworkWarnings(false)(dispatch);
  }

  useEffect(() => {
    setTimeout(() => {
      mounted.current && setShowMessage(true);
    }, 5000);
    return () => {
      mounted.current = false;
    };
  }, []);

  if (showMessage)
    return (
      <div className="slow-network-warning" onClick={onClose}>
        Warning, it seems that you have a slow network
        <span className="x">X</span>
      </div>
    );
  return null;
}
